
import { get, postJson, post, postFormData } from '@/utils/request'
export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 课后拿题接口
    async getKeHouTaskShitiByTaskId(context, params) {
      const res = await get('/Study/classStudyTask/getKeHouTaskShitiByTaskId', params)
      return res
    },
    // 课后任务单题提交
    async submitClassTaskShiti(context, params) {
      const res = await postJson('/Study/classStudyTask/submitClassTaskShiti', params)
      return res
    },
    // 课后任务退出提交
    async submitKeHouTaskByStop(context, params) {
      const res = await get('/Study/classStudyTask/submitKeHouTaskByStop', params)
      return res
    },
    // 获取视频播放接口
    async getVideoUrlByVideoId(context, params) {
      const res = await get('Study/tongbuyuxi/getVideoUrlByVideoId', params)
      return res
    },
    // 获取音频播放接口
    async getAudioUrlById(context, params) {
      const res = await post('Study/tool/v1/audio-url', params)
      return res
    },
    // 获取答题卡详情
    async getStudentAnswerResults(context, params) {
      const res = await get('/Study/classStudyTask/getStudentAnswerResults', params)
      return res
    },
    // 上传图片返回url接口
    async uploadTutoringPicture(context, params) {
      const res = await postFormData('/Study/program/uploadTutoringPicture', params)
      return res
    }

  }
}

